var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_239_33414",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_239_33414)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0H0V1.06667H24V0ZM24 2.13334H0V3.2H24V2.13334ZM0 4.26666H24V5.33333H0V4.26666ZM24 6.4H0V7.46666H24V6.4ZM0 8.53334H24V9.60001H0V8.53334ZM24 10.6667H0V11.7333H24V10.6667ZM0 12.8H24V13.8667H0V12.8ZM24 14.9333H0V16H24V14.9333Z",
    fill: "#D02F44"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.2857,
    height: 7.46667,
    fill: "#46467F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_239_33414)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.28592 1.59998C2.28592 1.89454 2.03009 2.13332 1.7145 2.13332C1.3989 2.13332 1.14307 1.89454 1.14307 1.59998C1.14307 1.30543 1.3989 1.06665 1.7145 1.06665C2.03009 1.06665 2.28592 1.30543 2.28592 1.59998ZM4.57164 1.59998C4.57164 1.89454 4.3158 2.13332 4.00021 2.13332C3.68462 2.13332 3.42878 1.89454 3.42878 1.59998C3.42878 1.30543 3.68462 1.06665 4.00021 1.06665C4.3158 1.06665 4.57164 1.30543 4.57164 1.59998ZM6.28592 2.13332C6.60151 2.13332 6.85735 1.89454 6.85735 1.59998C6.85735 1.30543 6.60151 1.06665 6.28592 1.06665C5.97033 1.06665 5.71449 1.30543 5.71449 1.59998C5.71449 1.89454 5.97033 2.13332 6.28592 2.13332ZM9.14307 1.59998C9.14307 1.89454 8.88723 2.13332 8.57164 2.13332C8.25605 2.13332 8.00021 1.89454 8.00021 1.59998C8.00021 1.30543 8.25605 1.06665 8.57164 1.06665C8.88723 1.06665 9.14307 1.30543 9.14307 1.59998ZM2.85735 3.19998C3.17294 3.19998 3.42878 2.9612 3.42878 2.66665C3.42878 2.3721 3.17294 2.13331 2.85735 2.13331C2.54176 2.13331 2.28592 2.3721 2.28592 2.66665C2.28592 2.9612 2.54176 3.19998 2.85735 3.19998ZM5.7145 2.66665C5.7145 2.9612 5.45866 3.19998 5.14307 3.19998C4.82748 3.19998 4.57164 2.9612 4.57164 2.66665C4.57164 2.3721 4.82748 2.13331 5.14307 2.13331C5.45866 2.13331 5.7145 2.3721 5.7145 2.66665ZM7.42878 3.19998C7.74437 3.19998 8.00021 2.9612 8.00021 2.66665C8.00021 2.3721 7.74437 2.13331 7.42878 2.13331C7.11319 2.13331 6.85735 2.3721 6.85735 2.66665C6.85735 2.9612 7.11319 3.19998 7.42878 3.19998ZM9.14307 3.73332C9.14307 4.02787 8.88723 4.26665 8.57164 4.26665C8.25605 4.26665 8.00021 4.02787 8.00021 3.73332C8.00021 3.43877 8.25605 3.19999 8.57164 3.19999C8.88723 3.19999 9.14307 3.43877 9.14307 3.73332ZM6.28592 4.26665C6.60151 4.26665 6.85735 4.02787 6.85735 3.73332C6.85735 3.43877 6.60151 3.19999 6.28592 3.19999C5.97033 3.19999 5.71449 3.43877 5.71449 3.73332C5.71449 4.02787 5.97033 4.26665 6.28592 4.26665ZM4.57164 3.73332C4.57164 4.02787 4.3158 4.26665 4.00021 4.26665C3.68462 4.26665 3.42878 4.02787 3.42878 3.73332C3.42878 3.43877 3.68462 3.19999 4.00021 3.19999C4.3158 3.19999 4.57164 3.43877 4.57164 3.73332ZM1.7145 4.26665C2.03009 4.26665 2.28592 4.02787 2.28592 3.73332C2.28592 3.43877 2.03009 3.19999 1.7145 3.19999C1.3989 3.19999 1.14307 3.43877 1.14307 3.73332C1.14307 4.02787 1.3989 4.26665 1.7145 4.26665ZM3.42878 4.79998C3.42878 5.09453 3.17294 5.33332 2.85735 5.33332C2.54176 5.33332 2.28592 5.09453 2.28592 4.79998C2.28592 4.50543 2.54176 4.26665 2.85735 4.26665C3.17294 4.26665 3.42878 4.50543 3.42878 4.79998ZM5.14307 5.33332C5.45866 5.33332 5.7145 5.09453 5.7145 4.79998C5.7145 4.50543 5.45866 4.26665 5.14307 4.26665C4.82748 4.26665 4.57164 4.50543 4.57164 4.79998C4.57164 5.09453 4.82748 5.33332 5.14307 5.33332ZM8.00021 4.79998C8.00021 5.09453 7.74437 5.33332 7.42878 5.33332C7.11319 5.33332 6.85735 5.09453 6.85735 4.79998C6.85735 4.50543 7.11319 4.26665 7.42878 4.26665C7.74437 4.26665 8.00021 4.50543 8.00021 4.79998ZM8.57164 6.39998C8.88723 6.39998 9.14307 6.1612 9.14307 5.86665C9.14307 5.57209 8.88723 5.33331 8.57164 5.33331C8.25605 5.33331 8.00021 5.57209 8.00021 5.86665C8.00021 6.1612 8.25605 6.39998 8.57164 6.39998ZM6.85735 5.86665C6.85735 6.1612 6.60151 6.39998 6.28592 6.39998C5.97033 6.39998 5.71449 6.1612 5.71449 5.86665C5.71449 5.57209 5.97033 5.33331 6.28592 5.33331C6.60151 5.33331 6.85735 5.57209 6.85735 5.86665ZM4.00021 6.39998C4.3158 6.39998 4.57164 6.1612 4.57164 5.86665C4.57164 5.57209 4.3158 5.33331 4.00021 5.33331C3.68462 5.33331 3.42878 5.57209 3.42878 5.86665C3.42878 6.1612 3.68462 6.39998 4.00021 6.39998ZM2.28592 5.86665C2.28592 6.1612 2.03009 6.39998 1.7145 6.39998C1.3989 6.39998 1.14307 6.1612 1.14307 5.86665C1.14307 5.57209 1.3989 5.33331 1.7145 5.33331C2.03009 5.33331 2.28592 5.57209 2.28592 5.86665Z",
    fill: "url(#paint0_linear_239_33414)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_239_33414",
    x: 1.14307,
    y: 1.06665,
    width: 8,
    height: 6.33337,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_239_33414"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_239_33414",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_239_33414",
    x1: 1.14307,
    y1: 1.06665,
    x2: 1.14307,
    y2: 6.39998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/US.ae6e5ead0b8b3d96a7493d33db513312.svg";
export { ForwardRef as ReactComponent };